// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

let logoHeaderOriginal = null;
let logoHeaderScroll = null;

(function () {
	// Initialize Lenis
	const lenis = new Lenis();

	// Use requestAnimationFrame to continuously update the scroll
	function raf(time) {
		lenis.raf(time);
		requestAnimationFrame(raf);
	}

	requestAnimationFrame(raf);

	let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu) => {
		if (itemMenu.querySelector('.submenu')) {
			const event = ["mouseenter", "mouseleave"];
			event.forEach((event) => {
				itemMenu.addEventListener(event, () => {
					itemMenu.classList.toggle('hover')
					itemMenu.querySelector('.submenu').classList.toggle('show')
				})
			})
		}
	})

	//mobile subnav
	let mobileLinks = document.querySelectorAll('.overlay .inner > ul > li');
	if (mobileLinks) {
		mobileLinks.forEach((itemMenu) => {
			let itemLink = itemMenu.querySelector('a');
			if (itemLink.nextElementSibling) {
				const event = ["click"];
				event.forEach((event) => {
					itemLink.addEventListener(event, (e) => {
						e.preventDefault();
						itemMenu.classList.toggle('hover')
						itemMenu.querySelector('.submenu').classList.toggle('show');
					})
				})
			}
		})
	}

	// checking links for form
	document.querySelectorAll('a:not(.skip-to-content)').forEach(anchor => {	
		if(anchor.getAttribute('href') != null) {
			if(anchor.getAttribute('href').startsWith('#')){
				anchor.addEventListener('click', function (e) {
					let currentTarget = anchor.getAttribute('href');
					if(document.querySelector(currentTarget)){
						e.preventDefault();
						document.querySelector(currentTarget).scrollIntoView({ behavior: 'smooth' });
					}
				});
			}
		}
	});

	//remove tabs remove margin
	if (document.querySelectorAll('.slider-with-tabs').length > 0) {
		document.querySelectorAll('.slider-with-tabs').forEach((tab) => {
			if (tab.nextElementSibling.classList.contains('background-yes')) {
				tab.classList.add('no-margin');
			}
		})
	}

	// Booking close button
	const bookingContent = document.querySelector('.booking-cms');

	window.onload = function () {
		const logoHeaderImg = document.querySelector(".js-scroll-logo img");
		if (logoHeaderImg) {
			logoHeaderOriginal = logoHeaderImg.getAttribute('src');
			logoHeaderScroll = logoHeaderImg.getAttribute('data-scroll');
		}

		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		});

	};

	const header = document.querySelector('.header');
	const navContainer = document.querySelector('.nav__container');
	document.addEventListener('click', function (e) {
		if (e.target.closest('.header__burger')) {
			header.classList.toggle('nav-open');
			navContainer.classList.toggle('open');
		} else if (e.target.closest('.js-close-menu')) {
			header.classList.remove('nav-open');
			navContainer.classList.remove('open');
		}
	});


	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//menu burger

	//open menu 
	document.querySelectorAll(".cta-menu-js").forEach(btn => {
		btn.addEventListener("click", (e) => {
			e.preventDefault();
			document.querySelector("#burger-menu").classList.add("open")
			document.querySelector("body").classList.add("no-scroll")
		}, false)
	});

	//close menu
	if (document.querySelector(".burger-close-js")) {
		document.querySelector(".burger-close-js").addEventListener("click", (e) => {
			e.preventDefault();
			document.querySelector("#burger-menu").classList.remove("open")
			document.querySelector("body").classList.remove("no-scroll")
		});
	}

	if (document.querySelector('.expand-submenu')) {
		document.querySelectorAll('.expand-submenu').forEach((expand) => {
			expand.addEventListener('click', () => {
				expand.classList.toggle('active-menu');
				expand.nextElementSibling.classList.toggle('show');
			})
		})
	}

	// Sub menu mobile
	document.querySelectorAll(".sub-menu").forEach(element => {
		element.addEventListener("click", () => {
			element.classList.toggle("active");
		});
	});

	//Animation Parallax image
	const images = document.querySelectorAll(
		'#home figure img:not(.no-parallax), #default figure img:not(.no-parallax), .parallax',
	);

	function initializeParallax() {
		if (typeof ukiyoInstances !== 'undefined') {
				ukiyoInstances.forEach(instance => instance.destroy());
		}

		ukiyoInstances = Array.from(images).map(img => new Ukiyo(img, {
				scale: 1.1,
				speed: 1.7,
				willChange: true,
		}));
	}

	let ukiyoInstances = [];
	initializeParallax();
	window.addEventListener('resize', () => {
		initializeParallax();
	});

	setTimeout(() => {
		if (document.querySelector('#termly-code-snippet-support')) {
			document.querySelector('#termly-code-snippet-support').setAttribute('data-lenis-prevent', '');
		}
	}, 1000);

	// Buttons to show forms
	const buttonsOpenForm = document.querySelectorAll('.js-open-form');
	const buttonsFloatingOpenForm = document.querySelectorAll('.js-floating-open-form');
	const closeForm = document.querySelectorAll('.js-close-button-form');

	if(buttonsOpenForm) {
		buttonsOpenForm.forEach(button => {
			button.addEventListener('click', () => {
				let form = document.querySelector('.hidden-form');
				let parentElement = button.closest('section');

				if(form) {
					if(parentElement.classList.contains('background-dark')) {
						form.parentNode.classList.add('p-15-0');
					} else {
						form.parentNode.classList.add('p-t-5', 'p-b-15');
					}

					form.classList.remove('hidden-form');
					form.classList.add('visible-form');
					form.scrollIntoView({ behavior: 'smooth' });
				}
			});
		});
	}

	if(buttonsFloatingOpenForm) {
		buttonsFloatingOpenForm.forEach(button => {
			button.addEventListener('click', (e) => {
				let form = document.querySelector('.hidden-form');
				let currentTarget = button.getAttribute('href');

				if(form) {
					form.classList.add('p-15-0');
					form.classList.remove('hidden-form');
					form.classList.add('visible-form');
				}

				if(document.querySelector(currentTarget)){
					e.preventDefault();
					document.querySelector(currentTarget).scrollIntoView({ behavior: 'smooth', block: 'center' });
				}
			});
		});
	}

	if(closeForm) {
		closeForm.forEach(btn => {
			btn.addEventListener('click', (e) => {
				let form = document.querySelector('.visible-form');

				form.parentNode.classList.remove(...form.parentNode.classList);
				form.parentNode.classList.add('group-start', 'background-light');
				form.classList.add('hidden-form');
				form.classList.remove('visible-form');
			});
		});
	}

	// Input DATE
	const dateFiles = document.querySelectorAll('form input[type="date"]');

	if(dateFiles) {
		dateFiles.forEach(input => {
			input.classList.add('show-placeholder');
	
			input.addEventListener('change', () => {
				if(!input.value || input.value == "") {
					input.classList.add('show-placeholder');
				} else {
					input.classList.remove('show-placeholder');
				}
			});
		});
	}
})();

function scrollW() {
	let st = window.pageYOffset || document.documentElement.scrollTop;
	let logoHeaderImg = document.querySelector(".js-scroll-logo img");
	const header = document.getElementById('header');

	// Always set original logo if header has 'no-header'
	if (header.classList.contains('no-header')) {
		logoHeaderImg.setAttribute("src", logoHeaderScroll);
		lastScrollTop = st <= 0 ? 0 : st;
		return;
	}

	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!header.classList.contains('down')) {
				header.classList.add('down');
				header.classList.remove('up');
				logoHeaderImg && logoHeaderScroll ? logoHeaderImg.setAttribute("src", logoHeaderScroll) : null;
			}
		} else {
			// upscroll code
			if (!header.classList.contains('up')) {
				header.classList.add('up');
				header.classList.remove('down');
				logoHeaderImg && logoHeaderScroll ? logoHeaderImg.setAttribute("src", logoHeaderScroll) : null;
			}
		}
	} else {
		if (header.classList.contains('up') || header.classList.contains('down')) {
			header.classList.remove('up');
			header.classList.remove('down');
			logoHeaderImg && logoHeaderOriginal ? logoHeaderImg.setAttribute("src", logoHeaderOriginal) : null;
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

document.addEventListener('DOMContentLoaded', () => {
	/* Lightbox Gallerys */
	const customLightbox = new LBX('.js-lbx-gallery', {
		customClass: 'lbx-gallery',
		icons: {
			close: '<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44"><g transform="translate(-20.682 0.142)"><g transform="translate(20.895 0.071)"><g transform="translate(-0.213 -0.213)" fill="#252525" stroke="#252525" stroke-width="1"><circle cx="22" cy="22" r="22" stroke="none"/><circle cx="22" cy="22" r="21.5" fill="none"/></g><path d="M17.984,17.984,0,0" transform="translate(12.31 30.168) rotate(-90)" fill="#252525" stroke="#fff" stroke-linecap="round" stroke-width="1"/><path d="M17.984,17.984,0,0" transform="translate(30.296 30.168) rotate(180)" fill="#252525" stroke="#fff" stroke-linecap="round" stroke-width="1"/></g></g></svg>',
			next: '<svg xmlns="http://www.w3.org/2000/svg" width="60.747" height="44.753" viewBox="0 0 60.747 44.753"><g transform="translate(-707.5 -88)"><g transform="translate(708 88)"><g transform="translate(0 0)"><g transform="translate(15.494 0)" fill="#252525" stroke="#fff" stroke-width="1"><circle cx="22.376" cy="22.376" r="22.376" stroke="none"/><circle cx="22.376" cy="22.376" r="21.876" fill="none"/></g><g  transform="translate(0 16.183)"><path d="M0,11.743,5.871,5.871,0,0" transform="translate(38.457)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/><path d="M33.144,0H0" transform="translate(0 5.899)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/></g></g></g></g></svg>',
			prev: '<svg xmlns="http://www.w3.org/2000/svg" width="60.747" height="44.753" viewBox="0 0 60.747 44.753"><g transform="translate(768.247 132.753) rotate(180)"><g transform="translate(708 88)"><g id="right" transform="translate(0 0)"><g id="Ellipse_90" data-name="Ellipse 90" transform="translate(15.494 0)" fill="#252525" stroke="#fff" stroke-width="1"><circle cx="22.376" cy="22.376" r="22.376" stroke="none"/><circle cx="22.376" cy="22.376" r="21.876" fill="none"/></g><g id="Group_1" data-name="Group 1" transform="translate(0 16.183)"><path id="Path_35897" data-name="Path 35897" d="M0,11.743,5.871,5.871,0,0" transform="translate(38.457)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/><path id="Path_24760" data-name="Path 24760" d="M33.144,0H0" transform="translate(0 5.899)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/></g></g></g></g></svg>'
		}
	});

	document.body.setAttribute('tabindex', '-1');
  document.body.style.outline = 'none';
  document.body.focus()
});

const tablesResp = document.querySelectorAll('.capacity-chart__copy table');

if (tablesResp.length) {
	tablesResp.forEach((tablei) => {
		let tableresponsive = document.createElement('div')
		tableresponsive.classList.add('tableHold')
		tablei.parentNode.insertBefore(tableresponsive, tablei)
		tableresponsive.append(tablei)
		const ths = tablei.querySelectorAll('tr:first-child > *')
		tablei.querySelectorAll('tr + tr').forEach((row) => {
			const tds = row.querySelectorAll('td')
			let i = 0
			for (i; i < tds.length; i++) {
				tds[i].setAttribute('data-label', ths[i].textContent)
			}
		})
		const rowHeads = tablei.querySelectorAll('tr td:first-child')
		rowHeads.forEach((ele) => {
			ele.addEventListener('click', (ev) => {
				rowHeads.forEach(e => {
					if(e != ele) {
						e.closest('tr').classList.remove('active');
					}
				});
				
				ele.closest('tr').classList.toggle('active');
			});
		});
	});
}

/** Keyboard Navigation - Accessibility Features **/
const menu = document.querySelector('.nav__container');
const closeMenuButton = document.querySelector('.js-close-menu');

function handleLastItemTab(e) {
	if (e.key === 'Tab' && !e.shiftKey) { 
		e.preventDefault();
		if (closeMenuButton) closeMenuButton.focus(); 
	}
}

function updateMenuTabIndex() {
	if (!menu) return;
	const isMenuVisible = menu.classList.contains('open');
	const elements = menu.querySelectorAll('.badge a, .privary-navigation__item a, .secondary-navigation__item a, .address a, .social-media li a, .autograph-hotels a, .js-close-menu');
	const elementsToHide = document.querySelectorAll('.header__logo, .btn-booking');

	const tabValue = isMenuVisible ? '0' : '-1';
	const hideTabValue = isMenuVisible ? '-1' : '0';

	elements.forEach((element, index) => {
		element.setAttribute('tabindex', tabValue);
		if (index === elements.length - 1) {
			element.removeEventListener('keydown', handleLastItemTab);
			if (isMenuVisible) element.addEventListener('keydown', handleLastItemTab);
		}
	});

  elementsToHide.forEach(el => el.setAttribute('tabindex', hideTabValue));
}

document.addEventListener('DOMContentLoaded', () => {
	updateMenuTabIndex();
	if (menu) menu.addEventListener('transitionend', updateMenuTabIndex);
	if (closeMenuButton) {
		closeMenuButton.addEventListener('click', function(e) {
			const firstHeaderElement = document.querySelector('.header__burger-label');
			if (firstHeaderElement) firstHeaderElement.focus();
		});
	}
});


// ADA TITLE IN IFRAME SINGLEPLATFORM

window.addEventListener('load', function() {
	const iframes = document.querySelectorAll('iframe[src*="singleplatform.com"]');
	if (iframes.length > 0) {
		iframes.forEach((iframe, index) => {
			let iframeTitle = iframe.getAttribute('src').split('.com/')[1].split('/')[0];
			if (iframeTitle) {
				iframeTitle = iframeTitle.replace(/-/g, ' ');
			} else {
				iframeTitle = 'Restaurant Menu';
			}
			iframe.setAttribute('title', 'Singleplatform - ' + iframeTitle + index);
		});
	}
});